<template>
  <div
    class="flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-full text-2xl font-bold text-white"
    :class="classes"
  >
    {{ stage }}
  </div>
</template>
<script>
export default {
  name: 'ContactStage',
  props: {
    stage: {
      type: Number,
    },
    currentStage: {
      type: Number,
    },
  },
  computed: {
    classes() {
      return {
        'bg-blue': this.currentStage > this.stage,
        'bg-blue-30': this.currentStage === this.stage,
        'bg-grey-20': this.currentStage < this.stage,
      };
    },
  },
};
</script>
